<template>
  <div ref="editmodal">
    <v-row justify="center">
      <v-container fluid>
        <v-dialog v-model="show" persistent max-width="600px">
          <custom-modal
            title="Edit Category"
            @onSubmit="SaveCategory"
            @onClose="show = false"
            :isLoading="isLoading"
          >
            <ValidationObserver ref="observer" v-slot="{ validate, reset }">
              <v-row>
                <v-col cols="6">
                  <ValidationProvider
                    v-slot="{ errors }"
                    name="Name"
                    vid="name"
                    rules="required"
                  >
                    <v-text-field
                      :error-messages="errors"
                      required
                      v-model="productcategory.name"
                      label="Name"
                      auto-grow
                      outlined
                      hide-details="auto"
                    ></v-text-field>
                  </ValidationProvider>
                </v-col>
                <v-col cols="6" sm="12" lg="6" md="6">
                  <ValidationProvider
                    v-slot="{ errors }"
                    name="Code"
                    vid="code"
                    rules="required"
                  >
                    <v-text-field
                      :error-messages="errors"
                      required
                      v-model="productcategory.code"
                      label="Code"
                      auto-grow
                      outlined
                      hide-details="auto"
                    ></v-text-field>
                  </ValidationProvider>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12">
                  <ValidationProvider
                    v-slot="{ errors }"
                    name="Parent Expense category"
                  >
                    <treeselect
                      hide-details="auto"
                      outlined
                      :error-messages="errors"
                      required
                      class="tree-border"
                      :value="id"
                      dense
                      v-model="productcategory.parent_id"
                      filled
                      :options="expense_categories_with_childs"
                      placeholder="Select your parent category"
                    >
                      <label
                        hide-details="auto"
                        slot="option-label"
                        slot-scope="{
                          node,
                          shouldShowCount,
                          count,
                          labelClassName,
                          countClassName,
                        }"
                        :class="labelClassName"
                      >
                        {{ node.raw.label }}
                        <span v-if="shouldShowCount" :class="countClassName"
                          >({{ count }})</span
                        >
                      </label>
                    </treeselect>
                    <span class="error--text">{{ errors[0] }}</span>
                  </ValidationProvider>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12">
                  <ValidationProvider v-slot="{ errors }" name="Description">
                    <v-textarea
                      hide-details="auto"
                      label="
                      Description"
                      :error-messages="errors"
                      required
                      v-model="productcategory.description"
                      outlined
                      rows="3"
                    ></v-textarea>
                  </ValidationProvider>
                </v-col>
              </v-row>
            </ValidationObserver>
          </custom-modal>
        </v-dialog>
      </v-container>
    </v-row>
  </div>
</template>
<script>
import { mapState } from 'vuex';

import { ProductCategory } from '../../../../../models/ProductCategory';
// import the component
import Treeselect from '@riophae/vue-treeselect';
// import the styles
import '@riophae/vue-treeselect/dist/vue-treeselect.css';
import FileUpload from '@/components/base/FileUpload';

import {
  extend,
  ValidationObserver,
  ValidationProvider,
  setInteractionMode,
} from 'vee-validate';
import { ExpenseCategory } from '@/models/ExpenseCategory';
export default {
  data: () => ({
    selectedImages: '',
    dialog: false,
    ParentProductCategories: [],
    value: [],
    existImage: [],
    options: [],
    isLoading: false,
    imageUpdated: null,
  }),
  created() {
    this.GetExpenseCategoriesWithChild();
    // this.GetCategory();
  },
  name: ' ',

  props: {
    visible: {
      type: Boolean,
      default: false,
    },

    productcategory: {
      type: Object,
      default: {},
    },
  },
  components: {
    ValidationProvider,
    ValidationObserver,
    Treeselect,
    FileUpload,
  },

  computed: {
    ...mapState('product', ['categories_with_child']),
    ...mapState('ExpenseSetting', ['expense_categories_with_childs']),
    show: {
      get() {
        return this.visible;
      },
      set(value) {
        if (!value) {
          this.$emit('close', this.productcategory);
          this.visible = value;
        }
      },
    },
  },
  methods: {
    GetExpenseCategoriesWithChild() {
      this.$store
        .dispatch('ExpenseSetting/GetExpenseCategoriesWithChild')
        .then((res) => {})
        .catch((err) => {
          this.$refs.observer.setErrors(err.data.error);
        });
    },
    onChangeImageUpload(value) {
      this.imageUpdated = value;
    },
    async SaveCategory() {
      const isValid = await this.$refs.observer.validate();
      if (isValid) {
        this.EditProductCategory();
      }
    },

    EditProductCategory() {
      this.isLoading = true;
      const credential = this.productcategory;
      this.$store
        .dispatch('sitesetting/EditExpenseCategory', {
          Id: credential.id,
          data: {
            name: credential.name,
            code: credential.code,
            description: credential.description,
            parent_id: credential.parent_id,
          },
        })
        .then(async (res) => {
          this.succeeed = true;
          this.$emit('afterSave');

          this.$toast.success('Expense category edited successfully.');

          this.show = false;
          this.visible = false;
          this.isLoading = false;
        })
        .catch((err) => {
          this.isLoading = false;
          this.$refs.observer.setErrors(err.data.error);
          this.$toast.error('Failed to edit expense category.');
        });
    },
  },
};
</script>

<style></style>
